import type { EducationPgmProgram } from "@/types";

export type TestGroupKeySource = {
  testId: string;
  testDefinition?: { oldTestId?: string | null } | null;
};

export const getTestGroupKey = (test: TestGroupKeySource): string => {
  if (test.testDefinition?.oldTestId) return test.testDefinition.oldTestId;

  return test.testId.replace(/TEST(?:1|R)$/, "TEST");
};

export const deduplicateTests = (
  tests: NonNullable<EducationPgmProgram["testHistory"]>
): NonNullable<EducationPgmProgram["testHistory"]> => {
  const bestByTestGroup = new Map<string, (typeof tests)[number]>();
  for (const t of tests) {
    const groupKey = getTestGroupKey(t);
    const existing = bestByTestGroup.get(groupKey);
    if (
      !existing ||
      (t.isPassed && !existing.isPassed) ||
      (!existing.isPassed && !t.isPassed && t.attemptNumber > existing.attemptNumber)
    ) {
      bestByTestGroup.set(groupKey, t);
    }
  }
  return Array.from(bestByTestGroup.values());
};
